import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

const AvaliacoesGoogle = () => {
  const avaliacoes = [
    {
      id: 1,
      nome: "M. S.",
      texto: "Fui atendido com muita clareza e profissionalismo. Consegui receber valores que nem sabia que tinha direito.",
      estrelas: 5
    },
    {
      id: 2,
      nome: "A. R.",
      texto: "Atendimento humano e técnico. Me orientou antes de pedir demissão e evitou prejuízo.",
      estrelas: 5
    },
    {
      id: 3,
      nome: "J. P.",
      texto: "Explicação detalhada e acompanhamento constante. Recomendo.",
      estrelas: 5
    }
  ];

  return (
    <section className="py-20 px-4 bg-white">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16 animate-fade-in-up">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-oxford mb-4">
            O que dizem nossos clientes
          </h2>
          <div className="w-32 h-1 bg-champagne mx-auto mb-6"></div>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Atendimento personalizado, técnica apurada e resultados reais
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {avaliacoes.map((avaliacao) => (
            <Card key={avaliacao.id} className="card-glass hover:scale-105 transition-transform duration-300">
              <CardContent className="p-6">
                {/* Estrelas - usando emoji ⭐️ */}
                <div className="flex gap-1 mb-4 text-2xl">
                  {[...Array(avaliacao.estrelas)].map((_, index) => (
                    <span key={index}>⭐</span>
                  ))}
                </div>

                {/* Texto da avaliação */}
                <p className="text-gray-700 leading-relaxed mb-4 italic">
                  "{avaliacao.texto}"
                </p>

                {/* Nome do cliente */}
                <p className="text-oxford font-semibold">
                  – {avaliacao.nome}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Selo Google */}
        <div className="flex justify-center items-center gap-2 text-sm text-gray-600">
          <div className="flex items-center gap-2 px-4 py-2 bg-oxford/5 rounded-full border border-oxford/10">
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
            </svg>
            <span className="font-medium text-oxford">Avaliações verificadas no Google</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AvaliacoesGoogle;
